import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { RequestHelper } from '../../../../../shared/helper/request.helper';
import { NavigationConstant } from '../../../../../shared/constant/navigation.constant';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {OvoStorage} from '../../../../../shared/storage/ovo.storage';
import { APIConstant } from 'src/app/shared/constant/api.constant';

@Component({
  selector: 'app-inquiry-ovo',
  templateUrl: './inquiry-ovo.component.html',
  styleUrls: ['./inquiry-ovo.component.css']
})
export class InquiryOvoComponent implements OnInit {
  form: FormGroup;
  inquiryResponse: any;
  isLoading: boolean;
  isSubmitted: boolean;
  hostname: any = environment.hostName;

  constructor(
    private apiService: RequestHelper,
    private router: Router,
    private ovoStorage: OvoStorage
  ) {
    this.isLoading = false;
    this.isSubmitted = false;
  }

  ngOnInit() {
    this.form = new FormBuilder().group({
      phoneNumber: [null, Validators.required],
      merchantInvoice: [null, Validators.required]
    });
  }

  submitInquiry() {
    this.isSubmitted = true;
    if (!this.form.valid) {
      return;
    }
    this.isLoading = true;
    this.apiService.post(environment.walletApiUrl + APIConstant.OVO_INQUIRY, JSON.stringify(this.form.getRawValue())).subscribe((data) => {
      this.ovoStorage.data = data;
      return this.router.navigate([NavigationConstant.OVO_PAYMENT]);
    }, (err) => this.isLoading = false);
    this.isLoading = false;
  }

  home() {
    this.apiService.home();
  }

}